import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { KnowledgePage, knowledgeTabSchema } from "#/pages/knowledge";

const knowledgeSearchSchema = z.object({
  // tab 是用户可以随手改的 URL 参数。两个都要：.catch 兜住非法值（只有 .default
  // 的话 validateSearch 会直接抛，整个后台白屏），.default 兜住参数缺失（只有
  // .catch 的话 navigate({ to: "/knowledge" }) 会被迫都带上 search）。
  tab: knowledgeTabSchema.catch("products").default("products"),
});

export const Route = createFileRoute("/_console/knowledge")({
  component: KnowledgeRoute,
  validateSearch: knowledgeSearchSchema,
});

/** 当前标签是路由状态：刷新和前进后退都要回到同一个标签（PRD 4.1）。 */
function KnowledgeRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <KnowledgePage
      onSectionChange={(section) => {
        void navigate({ search: { tab: section } });
      }}
      section={tab}
    />
  );
}
